export const track = (payload) => {
    window?.intuit?.tracking?.ecs?.webAnalytics?.track?.(payload);
};
export const buildScreenViewTrackingParams = (context) => {
    const { currentView, activeNav, joinCode, completedActivityTitle } = context;
    const buildParams = (screen, options = {}) => ({
        screen,
        options,
        key: `${screen}:${options.joinCode ?? ''}:${options.contentName ?? ''}`,
    });
    if (currentView === 'homepage') {
        return buildParams('homepage');
    }
    if (currentView === 'complete') {
        return buildParams('challenge_complete', {
            joinCode: joinCode || undefined,
            contentName: completedActivityTitle || undefined,
        });
    }
    if (currentView === 'dashboard') {
        if (activeNav === 'welcome') {
            return buildParams('welcome', { joinCode: joinCode || undefined });
        }
        if (activeNav === 'pre-survey') {
            return buildParams('pre_survey', { joinCode });
        }
        if (activeNav === 'activities') {
            return buildParams('activities', { joinCode: joinCode || undefined });
        }
        if (activeNav === 'post-survey') {
            return buildParams('post_survey', {
                joinCode,
                contentName: completedActivityTitle || undefined,
            });
        }
    }
    return null;
};
// Page viewed ------------------------------------------
export const trackScreenViewed = (screenOrContext, optionsOrLastKey = {}) => {
    const trackPayload = (screen, options = {}) => {
        const { joinCode, contentName } = options;
        track({
            object: 'content',
            action: 'viewed',
            ui_object: 'screen',
            ui_action: 'viewed',
            scope_area: 'hof',
            screen,
            ...(joinCode ? { classroom_join_code: joinCode } : {}),
            ...(contentName ? { content_name: contentName } : {}),
        });
    };
    if (typeof screenOrContext === 'string') {
        trackPayload(screenOrContext, optionsOrLastKey);
        return;
    }
    const params = buildScreenViewTrackingParams(screenOrContext);
    if (!params) {
        return null;
    }
    if (optionsOrLastKey === params.key) {
        return null;
    }
    trackPayload(params.screen, params.options);
    return params.key;
};
export const trackHomepageGetStartedClicked = () => {
    track({
        object: 'content',
        action: 'engaged',
        ui_object: 'button',
        ui_action: 'clicked',
        scope_area: 'hof',
        ui_object_detail: 'Get Started',
    });
};
export const trackWelcomeGetStartedClicked = (joinCode) => {
    track({
        object: 'content',
        action: 'engaged',
        ui_object: 'button',
        ui_action: 'clicked',
        scope_area: 'hof',
        screen: 'welcome',
        ui_object_detail: 'Get Started',
        ...(joinCode ? { classroom_join_code: joinCode } : {}),
    });
};
export const trackPreSurveySubmitClicked = (joinCode) => {
    track({
        object: 'content',
        action: 'engaged',
        ui_object: 'button',
        ui_action: 'clicked',
        scope_area: 'hof',
        screen: 'pre_survey',
        ui_object_detail: 'Submit Survey',
        classroom_join_code: joinCode,
    });
};
export const trackPostSurveySubmitClicked = (joinCode) => {
    track({
        object: 'content',
        action: 'engaged',
        ui_object: 'button',
        ui_action: 'clicked',
        scope_area: 'hof',
        screen: 'post_survey',
        ui_object_detail: 'Submit Survey',
        classroom_join_code: joinCode,
    });
};
// Activities ------------------------------------------
export const trackActivityStartClicked = (activityTitle, joinCode) => {
    track({
        object: 'content',
        action: 'engaged',
        ui_object: 'button',
        ui_action: 'clicked',
        scope_area: 'hof',
        screen: 'activities',
        ui_object_detail: 'Start',
        content_type: 'activity',
        content_name: activityTitle,
        ...(joinCode ? { classroom_join_code: joinCode } : {}),
    });
};
export const trackJoinChallengeClicked = (buttonText, joinCode) => {
    track({
        object: 'content',
        action: 'engaged',
        ui_object: 'button',
        ui_action: 'clicked',
        scope_area: 'hof',
        ui_object_detail: buttonText,
        ...(joinCode ? { classroom_join_code: joinCode } : {}),
    });
};
export const trackJoinCodeValidationResult = (status, joinCode) => {
    track({
        object: 'content',
        action: 'engaged',
        ui_object: 'join_code',
        ui_action: 'validation',
        scope_area: 'hof',
        ui_object_detail: `join_code_validation_${status}`,
        classroom_join_code: joinCode,
    });
};
